import doc                      from 'decorators/doc';
import model                    from 'decorators/model';
import { computed }             from 'mobx';
import PrivateDirectoryApiModel from '../../abstracts/DirectoryPrivateApiModel';

@model.staticLabel('Code NAF')
@model.urnResource('naf_code')
@doc.path('/naf_codes/{?id}')
export default class NafCodeModel extends PrivateDirectoryApiModel {
	public _filters: ModelFiltersExtended<{
		'code': string;
		'label': string;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'code': string;
	}> = {};

	@computed
	public get code(): string {
		return this.get('code', '');
	}

	@computed
	public get label(): string {
		return this.get('label', '');
	}
}
